const homePage = {
  path: 'homePage',
  component: resolve => require(['../../../../components/pages/signUp/homePage'], resolve)
}
export default homePage



// WEBPACK FOOTER //
// ./src/router/pages/signUp/homePage/index.js